import { useWindowSize } from "@hooks/useWindowSize"
import { EmptyLayout } from "@mosanic/components/Empty"
import RenderPage from "@mosanic/components/Pages"
import { useBreakpoint } from "@mosanic/hooks/Breakpoint"
import { dataSelector } from "@redux/map/data"
import { mapSelector } from "@redux/map"
import { useSelector } from "react-redux"
import { RenderHeaderFooter } from "../Page/Render"
 
import { StatusDot } from '@mosanic/items/Util'
import { updatePref } from '@redux/options/action'
import { isPreviewCanvasSelector } from '@redux/options/reducer'
import { useDispatch } from 'react-redux'
import styled from "styled-components"
import { CrossCircledIcon } from "@radix-ui/react-icons"
import { colors } from "@mosanic/styles"

const Close = styled.div` 
    transition: margin ease-in-out 0.5s, opacity ease-in 0.3s;
    opacity: 0;
    bottom: -20px;
    font-size: 12px;
    color: ${colors.util.gray.base};
`
const Float = styled.div` 
    position: fixed;
    bottom: 15px;
    right: 25px;
    z-index: 9999;
    background: rgba(255, 255, 255, 0.5);  
    padding: 10px;
    border-radius: 10px;
    box-shadow: 5px 5px 10px 0 rgba(0,0,0,0.2);
    backdrop-filter: blur(10px) invert(1);
    cursor: pointer;
    transition: all ease-in-out 0.3s;
    height: 45px;
    transform: translateZ(0);
    -webkit-font-smoothing: subpixel-antialiased;

    :hover {
        transform: scale(1.05) translateZ(0);
        backdrop-filter: none;
        background: #fff;
        height: 60px;
        
        ${Close} {
            opacity: 1;
            bottom: 0px;
        }
    }
`


export const Preview = ({}) => {
    const map = useSelector(mapSelector)
    const data = useSelector(dataSelector)
    const {width} = useWindowSize()
    const bp = useBreakpoint({});
    const [previewState, togglePreview, PreviewSwitch] = usePreviewSwitch();

    return (
        <div style={{background: '#fff', zIndex: 99, height: 'calc(100vh - 40px)', top: '40px', position: 'absolute'}}>
            {map?.length <= 0 ? (
                <EmptyLayout fontSize="18px" width={width} opacity={0.15}>
                    <div>
                    <h3>
                        Drop your first item in the canvas.
                    </h3>
                    <p>
                        Once you&apos;ve build up your layout, <br/>
                        Return to the preview.
                    </p>
                    </div>
                </EmptyLayout>
            ):(
              
                <RenderHeaderFooter bp={bp}>
                    <Float onClick={togglePreview}>
                        <PreviewSwitch />
                        <Close><CrossCircledIcon/> Close preview</Close>
                    </Float>
                    <RenderPage
                        page={{data, map}}
                        mode="prod"
                        level={0}
                    />
                </RenderHeaderFooter>
            
            )}
        </div>
    )
}


export const usePreviewSwitch = () => {
    const previewState = useSelector(isPreviewCanvasSelector)
    const dispatch = useDispatch();
    const togglePreview = () => dispatch(updatePref({group: 'builder', pref: 'previewMode'}))

    const Switch = ({}) => (
        <a>
            <StatusDot active={previewState} color={previewState ? "green" : "gray"} /> Preview mode
        </a>
    );
    return [
        previewState,
        togglePreview,
        Switch
    ]
}